module.exports = __webpack_public_path__ + "static/media/main-light.1c778836.png";